import { client } from "../../graphql/setDefault";
import {useAddress} from "@thirdweb-dev/react";
import { lensClient } from "../../client/LensClient";
import { ethers } from "ethers";
import { isRelaySuccess } from "@lens-protocol/client";
import { useEffect,useState } from "react";

import { toast} from 'react-toastify';
import "./interactionStyles.css"

export function Mirror({id}) {

    const address = useAddress();
    const provider = new ethers.providers.Web3Provider(window.ethereum);
    const signer = provider.getSigner();
    const [userID,setUserID] = useState();

  
    useEffect(()=>{
      async function fetchProfileId(){
        const profiles = await lensClient.profile.fetchAll({
          where: {
            ownedBy: [address],
          },
        })
        if(profiles.items.length!=0){
          setUserID(profiles?.items[0].id);
        }
      }
      fetchProfileId();
    },[])

    //v1 method to collect

    // useEffect(()=>{
    //     async function mirror(){
    //         if(data){
    //         console.log(id);
      
    //         const result = data.createMirrorTypedData;
    //         const typedData = result.typedData;
    //         if (!sdk) return;
    //         //Sign the typed data using the SDK
    //         const signature = await signTypedDataWithOmmittedTypename(sdk,typedData.domain, typedData.types, typedData.value)
    //         const { v, r, s } = splitSignature(signature.signature);
    //         //Send the typed data to the smart contract to perform the
    //         // write operation on the blockchain
    //         const lensHubContract = await sdk.getContractFromAbi(
    //             LENS_CONTRACT_ADDRESS,
    //             LENS_CONTRACT_ABI
    //         );
    //         // Call the smart contract function called "followWithSig"
    //         const tx = await lensHubContract.call("mirrorWithSig",{
    //             profileId: typedData.value.profileId,
    //             profileIdPointed: typedData.value.profileIdPointed,
    //             pubIdPointed: typedData.value.pubIdPointed,
    //             referenceModuleData: typedData.value.referenceModuleData,
    //             referenceModule: typedData.value.referenceModule,
    //             referenceModuleInitData: typedData.value.referenceModuleInitData,
    //             sig: {
    //             v,
    //             r,
    //             s,
    //             deadline: typedData.value.deadline,
    //             },
    //         });
    //         toast.info("Post Mirrored Successfully.",{
    //             position:toast.POSITION.TOP_CENTER
    //            })
    //     }
    //     else{
    //         console.log("no data");
    //     }
    // }
    // mirror();   
    // })

    

    async function handleMirror(){
        if (!address) {
            toast.info("You need to sign in first to interact with any post.",{
             position:toast.POSITION.TOP_CENTER
            })
        };    
        if(userID==null){
            toast.info("Please Sign Up or Create Your Profile.",{
              position:toast.POSITION.TOP_CENTER
             })
          }
          else{
            const profiles = await lensClient.profile.fetchAll({
              where: {
                ownedBy: [address],
              },
            })
  
            if(profiles.items.length==0){
              toast.info("Please Sign Up or Create Your Profile.",{
                position:toast.POSITION.TOP_CENTER
               })
            }
            else{
              setUserID(profiles?.items[0].id);
              
              const { id:authID, text } = await lensClient.authentication.generateChallenge({
                signedBy:address,
                for: userID, // e.g "0x01"
              });
              const signature = await signer.signMessage(text); // text returned from authentication.generateChallenge
              await lensClient.authentication.authenticate({ id:authID, signature:signature});    
            const resultTypedData = await lensClient.publication.createOnchainMirrorTypedData({
                mirrorOn: id[0].toString(),
            });
          
          const { id: dataID, typedData } = resultTypedData.unwrap();
          
          // sign with the wallet
          const signedTypedData = await signer._signTypedData(
            typedData.domain,
            typedData.types,
            typedData.value,
          );
                      
          const broadcastResult = await lensClient.transaction.broadcastOnchain({
            id:dataID,
            signature: signedTypedData,
          });
          
          const broadcastValue = broadcastResult.unwrap();
          
          if (!isRelaySuccess(broadcastValue)) {
            toast.info("Something went wrong",{
              position:toast.POSITION.TOP_CENTER
            })
            console.log(`Something went wrong`, broadcastValue)
            return
          }
          toast.success("Mirrored SuccessFully",{
            position:toast.POSITION.TOP_CENTER
          })
        }
    }}

    return(
        <div className = "intBtn">
            <button onClick = {()=>{handleMirror()}}><i className="fa-solid fa-retweet"></i></button>
        </div>
    );
}